export default __webpack_public_path__ + "static/media/027-helm.ea51af5e.png";